import { render, staticRenderFns } from "./PriceRow.vue?vue&type=template&id=5cf4ac2e&scoped=true"
import script from "./PriceRow.vue?vue&type=script&lang=js"
export * from "./PriceRow.vue?vue&type=script&lang=js"
import style0 from "./PriceRow.vue?vue&type=style&index=0&id=5cf4ac2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4ac2e",
  null
  
)

export default component.exports